var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Tree',{ref:"tree",staticClass:"tree-div",attrs:{"data":_vm.treeData,"show-checkbox":"","multiple":false},on:{"on-check-change":_vm.onCheckChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }